/* eslint-disable indent */
// import React from 'react'
// import { Route, Routes } from 'react-router-dom'
// import Admin from './pages/Admin'
// import Home from './pages/Home'
// import DisplayIdToken from './pages/DisplayIdToken'
// import DisplayUserInfo from './pages/DisplayUserInfo'
import React from 'react';
import { Route, Routes } from 'react-router-dom';
// import { createBrowserHistory } from 'history';
// import { connect } from 'react-redux';
// import Callback from './routes/Callback';
// import { initSessionFromCallbackURI } from './actions/session';
import Home from './routes/Home';
import Layout from './components/layout';
import LogIn from './components/login';
import Signup from './components/sign-up';
import Forgot from './components/forgot-password';
import Dashboard from './components/home';
import RecentFileListForm from './components/recent_file_form/Form_RecentFileForm';
import PreConfig from './components/preconfig_flowsheets';
import FlowSheetWizard from './components/flowSheet-Wizard';
import MyProjectsPopup from './components/my-projects';
import SharedProjectsPopup from './components/shared-projects';
// import './App.css';
import Flow from './components/Flow';
import './styles/global.scss';
import './components/save.css';
import FileHandling from './components/FileHandling';
import RoMachine from './components/ro-machine/RoMachine';
import CIPCalculator from './components/cip-calculator';
import ResetPassword from './components/reset-password';
import Maintaince from './components/maintaince/maintaince';
// import App360 from './components/app360';

const RouteList = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/sign-in" element={<LogIn />} />
        <Route path="/" element={<Home />} />
        <Route path="/main" element={<Flow />} />
        <Route path="/preconfig" element={<PreConfig />} />
        <Route path="/flowSheetWizard" element={<FlowSheetWizard />} />
        <Route path="/CIPCalculator" element={<CIPCalculator />} />
        <Route path="/my-projects" element={<MyProjectsPopup />} />
        <Route path="/shared-projects" element={<SharedProjectsPopup />} />
        <Route path="/filehandling" element={<FileHandling />} />
        <Route path="/home" element={<Dashboard />} />
        <Route path="/sign-up" element={<Signup />} />
        <Route path="/reset_pwd" element={<ResetPassword />} />
        <Route path="/forgot-password" element={<Forgot />} />
        <Route path="/recent-files-list" element={<RecentFileListForm />} />
        <Route path="/ro-machine" element={<RoMachine />} />
        <Route path="/maintaince" element={<Maintaince />} />

        {/* <Route path="/app360" element={<App360 /> } /> */}
      </Routes>
    </Layout>
  );
};

export default RouteList;